import 'css-chunk:../components/layout/sections/index.module.scss';export default {
  "sections": "_sections_19y20_1",
  "border": "_border_19y20_4",
  "normal": "_normal_19y20_9",
  "tight": "_tight_19y20_13",
  "tighter": "_tighter_19y20_17",
  "wide": "_wide_19y20_21",
  "wider": "_wider_19y20_25",
  "extra_wide": "_extra_wide_19y20_29",
  "none": "_none_19y20_33"
};